import m from "../../geodata/es2015/denmarkLow";
window.am4geodata_denmarkLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/denmarkLow.js
// module id = null
// module chunks = 